import {contentNoLevelNode} from "@/api/config";

const premiumType = {
    0: {name: '무료'},
    1: {name: '프리미엄'}
};

let noLevelNodeId = contentNoLevelNode


export {premiumType, noLevelNodeId};
